import { render } from "./InitialView.vue?vue&type=template&id=06f155c4&scoped=true"
import script from "./InitialView.vue?vue&type=script&lang=js"
export * from "./InitialView.vue?vue&type=script&lang=js"

import "./InitialView.vue?vue&type=style&index=0&id=06f155c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06f155c4"

export default script